import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { Table, TableModule } from 'primeng/table';
import { CalendarModule } from 'primeng/calendar';
import { FormsModule } from '@angular/forms';
import { CoreApiService } from '../../../core/service/core-api-service';
import { AppService } from '../../../core/service/app.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { properties } from '../../../../environments/properties';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { DropdownModule } from 'primeng/dropdown';

@Component({
  selector: 'app-list-user',
  standalone: true,
  imports: [
    TableModule,
    ButtonModule,
    DividerModule,
    CommonModule,
    CalendarModule,
    FormsModule,
    DropdownModule,
  ],
  providers: [ConfirmationService, MessageService],
  templateUrl: './list-user.component.html',
  styleUrl: './list-user.component.css',
})
export class ListUserComponent implements OnInit{
  @ViewChild('dt1') table!: Table;
  titulo: string = 'Lista de usuarios';
  ltsUsers: any[] = [];
  dateStart: Date = new Date();
  dateEnd: Date = new Date();
  ltsStates: any[] = [];
  filteredUsers: any[] = [];
  selectedState: any = null;

  constructor(
    private readonly apiService: CoreApiService, 
    private readonly util: AppService) {}

  ngOnInit(): void {
    this.dateStart.setDate(this.dateEnd.getDate() - 10);
    this.getListUsers();
  }

  getListUsers(): void {
    const queryParams = {
      startDate: this.dateStart?.toISOString().split('T')[0],
      endDate: this.dateEnd?.toISOString().split('T')[0],
    };
    this.apiService.consumirWSGet(
      properties.serviceListUsers,
      queryParams,
      (data) => {
        if (data.estado === properties.codeOK) {
          this.ltsUsers = data.data;
          this.filteredUsers = this.ltsUsers;
          this.buildStates(this.ltsUsers);
          this.applyFilters();
        } else {
          this.util.mostrarToast(
            'Lista de usuarios',
            'Error al obtener la lista de usuarios',
            4
          );
        }
      }
    );
  }

  onStateChange() {
    this.applyFilters();
    if (this.table) {
      this.table.first = 0;
    }
  }

  private buildStates(users: any[]) {
    this.ltsStates = [
      { pd_name: 'Todos', pd_code: null },
      ...[...new Set(users.map((u) => u.pd_name))]
        .filter((name) => !!name)
        .map((name) => ({
          pd_name: name,
          pd_code: name,
        })),
    ];
  }

  applyFilters() {
    this.ltsUsers = [...this.filteredUsers];
    this.ltsUsers = this.ltsUsers.filter((user) => {
      // filtro por ciudad
      const matchState = this.selectedState
        ? user.pd_name === this.selectedState
        : true;

      // filtro por fecha
      const userDate = new Date(user.crea_date);
      const matchStart = this.dateStart ? userDate >= this.dateStart : true;
      const matchEnd = this.dateEnd ? userDate <= this.dateEnd : true;

      return matchState && matchStart && matchEnd;
    });
  }

  exportToExcel() {
    const dataExport = this.ltsUsers.map((user) => ({
      ID: user.usr_id,
      Nombre: user.usr_name,
      Apellido: user.usr_last_name,
      Telefono: user.usr_phone,
      Email: user.usr_email ? user.usr_email : 'Sin información',
      'Fecha de registro': this.formatearFecha(user.crea_date),
      Ciudad: user.pd_name ? user.pd_name : 'Sin información',
    }));

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataExport);
    const workbook: XLSX.WorkBook = {
      Sheets: { Usuarios: worksheet },
      SheetNames: ['Usuarios'],
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });

    this.saveAsExcelFile(excelBuffer, 'usuarios');
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
    });
    saveAs.saveAs(data, `${fileName}_export_${new Date()}.xlsx`);
  }

  private formatearFecha(fecha: string | Date): string {
    if (!fecha) return '';
    const d = new Date(fecha);
    const dia = String(d.getDate()).padStart(2, '0');
    const mes = String(d.getMonth() + 1).padStart(2, '0');
    const anio = d.getFullYear();
    return `${dia}-${mes}-${anio}`;
  }
}
